export const UPDATE_MARSHAL_REPORT = 'UPDATE_MARSHAL_REPORT';
export const GENERATE_REPORT = 'GENERATE_BANK_REPORT';
export const SCHEDULE_VISIT = 'SCHEDULE_VISIT';
export const FETCH_REPORTS = 'FETCH_REPORTS';
export const CREATE_BANK = 'CREATE_BANK';
export const FETCH_MARSHALS = 'FETCH_MARSHALS';
export const DOWNLOAD_MARSHAL_REPORT = 'DOWNLOAD_MARSHAL_REPORT';


export const CREATE_ROUTE_MARSHAL = 'CREATE_ROUTE_MARSHAL';
export const UPDATE_ROUTE_MARSHAL = 'UPDATE_ROUTE_MARSHAL';
export const DELETE_ROUTE_MARSHAL = 'DELETE_ROUTE_MARSHAL';
export const GENERATE_BANK_REPORT = 'GENERATE_BANK_REPORT';




